import { faCircleXmark, faUserTimes } from '@fortawesome/free-solid-svg-icons';
import { isClaimedVehicle, isSharedVehicle, isUnclaimableVehicle, isUnclaimedVehicle } from 'myParkdUtils/utils';
import { FormattedMessage } from 'react-intl';
import { ReduxState, VehicleAndDriver } from 'types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { AnyAction, Dispatch, bindActionCreators } from 'redux';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import * as vehiclesActions from 'features/vehicles/vehiclesActions';
import { ModalEnum } from 'myParkdUtils/enums';
import { Api } from 'api';
import { formatMessage } from 'i18n/CurrentLocale';
import { unclaimFailedModal } from 'myParkdUtils/basicMessageModalContent';


export const handleUnclaimApiError = (error: any, updateModal: Function) => {
    const hasErrorKey = (error: any, errorKey: string) => {
        return error.response.body && error.response.body.data && error.response.body.data.errorKey === errorKey;
    };

    if (error.status === 404) {
        updateModal(ModalEnum.BASIC_MESSAGE_MODAL, {
            modalContent: unclaimFailedModal(formatMessage({ id: 'MODAL_TEXT_UNCLAIM_ERROR_404' }), 'could-not-unclaim'),
        });
    } else if (error.status === 409 && hasErrorKey(error, 'CANNOT_UNCLAIM_DURING_ACTIVE_SESSION')) {
        updateModal(ModalEnum.BASIC_MESSAGE_MODAL, {
            modalContent: unclaimFailedModal(formatMessage({ id: 'MODAL_TEXT_UNCLAIM_ERROR_ACTIVE_SESSION' }), 'could-not-unclaim-active-session-error-message'),
        });
    } else if (error.status === 409 && hasErrorKey(error, 'START_AFTER_PARKING_BREAK_PENDING')) {
        updateModal(ModalEnum.BASIC_MESSAGE_MODAL, {
            modalContent: unclaimFailedModal(formatMessage({ id: 'MODAL_TEXT_UNCLAIM_ERROR_PENDING_START' }), 'could-not-unclaim-pending-start'),
        });
    } else {
        updateModal(ModalEnum.BASIC_MESSAGE_MODAL, {
            modalContent: unclaimFailedModal(formatMessage({ id: 'PARKD_API_ERROR_FATAL_ERROR' }), 'unhandled-error-unclaim'),
        });
    }
};


export const DriverRenderer = (props: Props) => {

    const vehicleAndDriver = props.vehicleAndDriver;
    const parkingMode = vehicleAndDriver.vehicle.mode;
    const { claimState } = vehicleAndDriver.vehicle;
    const { user } = vehicleAndDriver;

    const decoupleDriver = () => {
        props.updateModal(ModalEnum.CONFIRMATION_DIALOG, {
            modalTitle: (
                <>
                    <FontAwesomeIcon icon={faUserTimes} />
                    <FormattedMessage id="MODAL_TITLE_UNCLAIM_DRIVER_FROM_VEHICLE" />
                </>
            ),
            modalText: (
                <FormattedMessage
                    id="MODAL_TEXT_UNCLAIM_DRIVER_FROM_VEHICLE"
                    values={{
                        fullName: vehicleAndDriver?.user?.fullName,
                        licensePlate: vehicleAndDriver.vehicle.localizedLicensePlate.licensePlate,
                    }}
                />
            ),
            confirmButtonText: <FormattedMessage id="UNCLAIM" />,
            loadingMessage: <FormattedMessage id="MODAL_STATUS_UNCLAIMING_VEHICLE" />,
            successMessage: <FormattedMessage id="MODAL_STATUS_UNCLAIMED_SUCCESSFULLY" />,
            actionOnConfirm: async () => {
                await Api.unclaimVehicle(
                    props.token!,
                    vehicleAndDriver.vehicle.localizedLicensePlate.countryCode,
                    vehicleAndDriver.vehicle.localizedLicensePlate.licensePlate
                );
            },
            actionOnCompleted: () => {
                props.removeDriverAfterUnclaim(vehicleAndDriver);
            },
            actionOnError: (error: any) => {
                handleUnclaimApiError(error, props.updateModal);
                console.error(error);
            },
        });
    }

    if (isClaimedVehicle(claimState, user)) {
        return (
            <>
                <FontAwesomeIcon
                    icon={faCircleXmark}
                    size='lg'
                    className='icon-circle-x'
                    onClick={decoupleDriver}
                    data-testid='btn-decouple-driver'
                />
                <span>{user?.fullName}</span>
            </>
        );
    } else if (isSharedVehicle(parkingMode)) {
        return (
            <span className='vehicle-unclaimable'><FormattedMessage id="SHARED_VEHICLE" /></span>
        );
    } else if (isUnclaimedVehicle(claimState)) {
        return (
            <span className='vehicle-unclaimed'><FormattedMessage id="UNCLAIMED" /></span>
        );
    } else if (isUnclaimableVehicle(claimState)) {
        return (
            <span className='vehicle-unclaimable'><FormattedMessage id="UNCLAIMABLE" /></span>
        );
    } else {
        return null;
    }
};


type OwnProps = {
    vehicleAndDriver: VehicleAndDriver
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps & OwnProps;

function mapStateToProps(state: ReduxState) {
    return {
        token: state.auth?.token
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        updateModal: modalWindowActions.updateModalWindow,
        removeDriverAfterUnclaim: vehiclesActions.removeDriverAfterUnclaim,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverRenderer);